import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2044Status: 'idle',
    startProcess2044Error: undefined as any,
    loadUserParamsProcess2044Status: 'idle',
    loadUserParamsProcess2044Error: undefined as any,

    process2044List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2044 = createAsyncThunk('process2044Slice/startProcess2044', async ({ process2044 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2044/`,
        prepareData(process2044),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2044Status } = getState().process2044Slice
        return startProcess2044Status !== 'pending'
    }
})

export const loadUserParamsProcess2044 = createAsyncThunk('process2044Slice/loadUserParamsProcess2044', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2044/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2044Status } = getState().process2044Slice
        return loadUserParamsProcess2044Status !== 'pending'
    }
})

const Process2044Slice = createSlice({
    name: 'process2044Slice',
    initialState,
    reducers: {
        resetstartProcess2044: (state) => {
            state.job = undefined
            state.startProcess2044Error = undefined
        },
        resetstartProcess2044Error: (state) => {
            state.startProcess2044Error = undefined
        },
        resetloadUserParamsProcess2044: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2044Error = undefined
        },
        resetloadUserParamsProcess2044Error: (state) => {
            state.loadUserParamsProcess2044Error = undefined
        },
        removeFromProcess2044ListById: (state, action) => {
            state.process2044List = state.process2044List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2044ListByIds: (state, action) => {
            state.process2044List = state.process2044List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2044List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2044Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2044List = []
            state.startProcess2044Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2044.pending, (state) => {
            state.startProcess2044Status = 'pending'
            state.startProcess2044Error = undefined
        })
        builder.addCase(startProcess2044.fulfilled, (state, action) => {
            state.startProcess2044Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2044.rejected, (state, action) => {
            state.startProcess2044Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2044Error = action.error.message
            } else {
                state.startProcess2044Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2044.pending, (state) => {
            state.loadUserParamsProcess2044Status = 'pending'
            state.loadUserParamsProcess2044Error = undefined
        })
        builder.addCase(loadUserParamsProcess2044.fulfilled, (state, action) => {
            state.loadUserParamsProcess2044Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2044.rejected, (state, action) => {
            state.loadUserParamsProcess2044Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2044Error = action.error.message
            } else {
                state.loadUserParamsProcess2044Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2044,
    resetstartProcess2044Error,
    resetloadUserParamsProcess2044,
    resetloadUserParamsProcess2044Error,
    removeFromProcess2044ListById,
    removeFromProcess2044ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2044Slice.actions
export default Process2044Slice.reducer
